<template>
  <div class="admin-card mt-3">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 class="font-weight-bold mb-0" style="color:#0f172a;">
            <i class="bi bi-graph-down-arrow text-danger mr-1"></i> Churn Risk
          </h6>
          <small class="text-secondary">Merchants active 8–30 days ago with no orders in the last 7 days</small>
        </div>
        <button class="btn btn-outline-secondary" @click="fetch" :disabled="loading">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>

      <div v-if="loading" class="text-center py-3">
        <div class="spinner-border text-secondary" role="status"></div>
      </div>

      <div v-else-if="risks.length === 0" class="text-center text-primary py-3">
        <i class="bi bi-check-circle-fill" style="font-size:1.5rem;"></i>
        <p class="mt-2 mb-0"><small>No churn risk detected</small></p>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Merchant</th>
              <th class="text-center">Orders 30d</th>
              <th class="text-center">Orders 7d</th>
              <th class="d-none d-md-table-cell">Days Silent</th>
              <th class="d-none d-md-table-cell">Billing</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in risks" :key="r.id">
              <td class="align-middle font-weight-bold" style="font-size:.85rem;">{{ r.name }}</td>
              <td class="align-middle text-center">
                <span class="badge badge-secondary">{{ r.orders_last_30d }}</span>
              </td>
              <td class="align-middle text-center">
                <span :class="['badge', r.orders_last_7d === 0 ? 'badge-danger' : 'badge-dark']">{{ r.orders_last_7d }}</span>
              </td>
              <td class="align-middle d-none d-md-table-cell">
                <small class="text-secondary">{{ r.days_silent !== null ? r.days_silent + 'd' : '—' }}</small>
              </td>
              <td class="align-middle d-none d-md-table-cell">
                <small :class="r.overdue ? 'text-danger font-weight-bold' : 'text-secondary'">
                  {{ r.overdue ? 'Overdue' : r.billing_due ? formatDate(r.billing_due) : '—' }}
                </small>
              </td>
              <td class="align-middle text-right">
                <button
                  class="btn btn-outline-primary"
                  style="padding:1px 7px;font-size:.75rem;"
                  @click="$emit('view-company', r)"
                  title="View in drawer"
                >
                  <i class="bi bi-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminChurnRisk',

  data() {
    return {
      loading: false,
      risks: [],
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/admin/charts/churn-risk');
        this.risks = data;
      } finally {
        this.loading = false;
      }
    },

    formatDate(d) {
      return moment(d).format('D MMM YY');
    },
  },
};
</script>

<style scoped>
.admin-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
}
</style>
